// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1xd1b","range":"MonthRangeSwitch_range__3GYd0","disabled":"MonthRangeSwitch_disabled__1iZwF"};